import { createActionGroup, props } from '@ngrx/store';
import { AvaEntity } from '../../entities/ava.entity';
import { AvaAddRequest, AvaDeleteRequest, AvaEditRequest } from '@dave/types/dist/proto/ava/ava';
import { UploadActionProps } from '../../guards/resolver.helper';

export const AvaActions = createActionGroup({
    source: 'Ava',
    events: {
        'Load Success': props<{ Payload: AvaEntity[] }>(),
        'Load Request': props<UploadActionProps/*{ Payload?: AvaGetRequest }*/>(),
        'Load Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        'Add Success': props<{ Payload: AvaEntity }>(),
        'Add Request': props<{ Payload: AvaAddRequest }>(),
        'Add Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        'Change Success': props<{ Payload: AvaEntity }>(),
        'Change Request': props<{ Payload?: AvaEditRequest }>(),
        'Change Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        'Delete Success': props<{ Payload: number }>(),
        'Delete Request': props<{ Payload: AvaDeleteRequest }>(),
        'Delete Failure': props<{ Errors: any; ToasterMessage?: string }>(),
    },
});
